import { columnsOptions } from "./columnsConfig";
import { checkPrevMonthSelection } from "./dateHelpers";

export const generateColumns = (renderCells, t, overrideActionLabel = '', selectedDate = '', dateOptions: string[] = []) => {
  const columns: any = [];
  // columns.push({ field: 'id', headerName: '#', ...columnsOptions.id });
  Object.keys(columnsOptions).forEach((key) => {
    const column = (renderCells[key]) ? {
      ...columnsOptions[key], renderCell: renderCells[key]
    } : columnsOptions[key];
    if (key !== 'actions') {
      columns.push({
        ...column,
        field: key,
        headerName: t(`PairingTableColumns.${key}`),
      });
    }
  });
  if (!checkPrevMonthSelection(selectedDate, dateOptions)) {
    columns.push({
      ...columnsOptions.actions,
      renderCell: renderCells.actions,
      headerName: overrideActionLabel ? t(`PairingTableColumns.${overrideActionLabel}`) : columnsOptions.actions.headerName,
      width: overrideActionLabel ? 90 : columnsOptions.actions.width
    });
  }
  return columns;
}
